import * as React from 'react';
import {default as MuiAppBar} from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';

import { Link as RouterLink, useLocation } from "react-router-dom";
import { AppContext } from './AppContext';

interface AppBarProps {
  pages: Page[]
}

interface Page {
  label: string;
  route: string
}

const FULL_NAVIGATION_MIN_WIDTH_PX = 1700;
const DRAWER_WIDTH = 260;

export default function AppBar ({pages}: AppBarProps) {
  const {signOut} = React.useContext(AppContext);

  const location = useLocation();

  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const inlineNav = useMediaQuery(`(min-width:${FULL_NAVIGATION_MIN_WIDTH_PX}px)`, {noSsr: true});

  return <>
    <MuiAppBar position='static'>
      <Toolbar>
        {inlineNav ? (
          <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex' }}>
              {pages.map((page) => (
                <Button
                  key={page.route}
                  component={RouterLink}
                  to={page.route}
                  sx={{
                    my: 2,
                    color: 'white',
                    border: `1px solid ${location.pathname === page.route ? 'white' : 'primary'}`,
                    display: 'block',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {page.label.toUpperCase()}
                </Button>
              ))}
            </Box>

            <Button
              sx={{ my: 2, color: 'white', display: 'block', whiteSpace: 'nowrap' }}
              onClick={() => signOut()}
            >
              Sign out
            </Button>
          </Box>
        ) : (
          <>
            <IconButton
              color='inherit'
              aria-label='open navigation'
              edge='start'
              onClick={() => setDrawerOpen(true)}
            >
              <MenuIcon />
            </IconButton>

            <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                sx={{ color: 'white', whiteSpace: 'nowrap' }}
                onClick={() => signOut()}
              >
                Sign out
              </Button>
            </Box>
          </>
        )}
      </Toolbar>
    </MuiAppBar>

    <Drawer
      anchor='left'
      open={drawerOpen && !inlineNav}
      onClose={() => setDrawerOpen(false)}
      ModalProps={{ keepMounted: true }}
    >
      <Box sx={{ width: DRAWER_WIDTH }} role='navigation'>
        <List>
          {pages.map((page) => (
            <ListItem key={page.route} disablePadding>
              <ListItemButton
                component={RouterLink}
                to={page.route}
                selected={location.pathname === page.route}
                onClick={() => setDrawerOpen(false)}
              >
                <ListItemText primary={page.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={() => signOut()}>
              <ListItemText primary='Sign out' />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
    </Drawer>
  </>
}
